const notice = {
  notificationType: "ประเภทการแจ้งเตือน",
  notificationType1: "สัญญาณเตือนโหมดความปลอดภัย",
  notificationType3: "เตือนความปลอดภัย",
  notificationType4: "เตือนขอบเขตแจ้งเตือนทางภูมิศาสตร์",
  notificationType5: "สัญญาณเตือนออฟไลน์ / ออนไลน์",
  notificationType6: "กิจกรรมที่เหลือ",
  notificationType7: "ข้อความระบบ",
  notificationType8: "เตือนความเร็วเกิน",
  notificationType9: "รายงานการเดินทาง",
  isdisabled: "สถานะบัญชี",
  title: "หัวข้อ",
  content: "เนื้อหา",
  pushOrNot: "สถานะการส่ง",
  readOrNot: "สถานะการอ่าน",
  search: {
    width1: "80px",
    width2: "80px",
    width3: "100px",
    width4: "100px"
  },
  yes: "ใช่",
  no: "ไม่",
  dialog: {
    pushTitle: "ชื่อการแจ้งเตือน",
    pushContent: "เนื้อหาการแจ้งเตือน",
    selectUsers: "เลือกผู้ใช้",
    pushAll: "แจ้งเตือนผู้ใช้ทั้งหมดหรือไม่",
    noTitle: "โปรดป้อนชื่อ",
    noContent: "กรุณาใส่เนื้อหา",
    noUser: "โปรดเลือกผู้ใช้",
    labelWidth: "140px"
  },
  user: {
    loginName: "ชื่อล็อกอิน",
    disableOrNot: "ปิดการใช้งานหรือไม่"
  }
} 
export default notice